module.exports = __webpack_public_path__ + "38bc10cd6b6ce2c877051daf06e703d4.MP3";